import { render, staticRenderFns } from "./smFooter.vue?vue&type=template&id=3a931c88"
import script from "./smFooter.vue?vue&type=script&lang=js"
export * from "./smFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports